import { useEffect, useReducer } from 'react'

import { GENERATION_PHASE } from 'Pods/ThreeDStudio/Store/constants'

export const QUEUED_HOLD_MS = 2000

/**
 * The phase the card should display: the run's live phase, except that
 * "Waiting in queue..." is held for at least QUEUED_HOLD_MS from the run's start
 * so an immediate phase broadcast does not flash the queued title away.
 * @param {object|undefined} run - The watched activeRuns entry
 * @returns {string} A GENERATION_PHASE value
 */
export default function useDisplayPhase(run) {
  const phase = run?.phase ?? GENERATION_PHASE.QUEUED
  const startedAt = run?.startedAt ?? null
  const [, endHold] = useReducer((count) => count + 1, 0)
  const holdUntil = startedAt == null ? 0 : startedAt + QUEUED_HOLD_MS
  const isHolding = phase !== GENERATION_PHASE.QUEUED && Date.now() < holdUntil

  useEffect(() => {
    if (!isHolding) {
      return undefined
    }

    const timeoutId = setTimeout(endHold, Math.max(holdUntil - Date.now(), 0))
    return () => clearTimeout(timeoutId)
  }, [isHolding, holdUntil])

  return isHolding ? GENERATION_PHASE.QUEUED : phase
}
